import { render, staticRenderFns } from "./Videocall.vue?vue&type=template&id=b84de344&scoped=true"
import script from "./Videocall.vue?vue&type=script&lang=js"
export * from "./Videocall.vue?vue&type=script&lang=js"
import style0 from "./Videocall.vue?vue&type=style&index=0&id=b84de344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84de344",
  null
  
)

export default component.exports